/** Intervalo entre verificações proativas de `version.json` (alinhado ao throttle do SW em main). */
export const SYNAP_PWA_VERSION_CHECK_INTERVAL_MS = 6 * 60 * 1000
